let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("9wxKg"), load("kIryJ")]).then(() => parcelRequire('j2TUq'));